import React, { useMemo } from 'react';
import { RefreshControl, ScrollView } from 'react-native';
import { Dialog, List } from '../../components';
import { ListContainer } from '../../containers';
import { useRefreshPage } from '../../hooks';
import { useThemedStyles } from '../../hooks/useThemedStyles';

import TicketListItem from './TicketListItem';

const TicketList = ({ items, modifyItem, refetch, showMachineName, isTicketList, emptyListMessage }) => {
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);
	const styles = useThemedStyles(createStyles);

	const customProps = useMemo(() => ({
		modifyItem,
		showMachineName,
		isTicketList,
	}), [isTicketList, modifyItem, showMachineName]);

	return (
		<>
			<ScrollView
				style={styles.scrollView}
				scrollIndicatorInsets={{ right: 1 }}
				refreshControl={(
					<RefreshControl
						refreshing={isRefreshing}
						onRefresh={refreshPage}
					/>
				)}
			>
				<List
					listItemComponent={TicketListItem}
					items={items}
					customProps={customProps}
					emptyListMessage={emptyListMessage}
				/>
			</ScrollView>

			<Dialog />
		</>
	);
};

const createStyles = () => ({
	scrollView: {
		flex: 1,
	},
});

export default ListContainer(TicketList);
